import { jsx as _jsx } from "react/jsx-runtime";
const SliderWrapper = ({ children }) => {
    return (_jsx("div", { "data-testid": "slider", className: "flex h-16 w-full max-w-md items-center", children: children }));
};
export default SliderWrapper;
